export default __webpack_public_path__ + "static/WeatherAppDisplay-a677c0c7fbca1c3681bfdbc5655cdb23.png";